function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-26.9)"
}, React.createElement("g", {
  transform: "translate(26.9)"
}, React.createElement("path", {
  className: "a",
  d: "M44.994,3.022H40.625V2.31A2.312,2.312,0,0,0,38.315,0H34.162a2.312,2.312,0,0,0-2.31,2.31v.712H27.483a.583.583,0,1,0,0,1.166h1.053V17.883A3.121,3.121,0,0,0,31.653,21h9.17a3.121,3.121,0,0,0,3.117-3.117V4.188h1.053a.583.583,0,1,0,0-1.166ZM33.018,2.31a1.146,1.146,0,0,1,1.144-1.144h4.153A1.146,1.146,0,0,1,39.459,2.31v.712H33.018Zm9.757,15.573a1.955,1.955,0,0,1-1.951,1.951h-9.17A1.955,1.955,0,0,1,29.7,17.883V4.188H42.78V17.883Z",
  transform: "translate(-26.9)"
}), React.createElement("path", {
  className: "a",
  d: "M230.283,156.867a.58.58,0,0,0,.583-.583v-10.3a.583.583,0,1,0-1.166,0v10.3A.584.584,0,0,0,230.283,156.867Z",
  transform: "translate(-220.944 -139.122)"
}), React.createElement("path", {
  className: "a",
  d: "M142.183,170.385a.58.58,0,0,0,.583-.583v-9.019a.583.583,0,1,0-1.166,0V169.8A.583.583,0,0,0,142.183,170.385Z",
  transform: "translate(-136.648 -153.283)"
}), React.createElement("path", {
  className: "a",
  d: "M318.383,170.385a.58.58,0,0,0,.583-.583v-9.019a.583.583,0,0,0-1.166,0V169.8A.58.58,0,0,0,318.383,170.385Z",
  transform: "translate(-305.241 -153.283)"
})));

var SvgGarbage = function SvgGarbage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18.677,
    height: 21,
    viewBox: "0 0 18.677 21",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGarbage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/garbage.d4f2c877.svg";
export { ForwardRef as ReactComponent };